/* eslint-disable max-len */
import React, { useContext } from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import _ from 'lodash';
import { Acl } from 'modules/common/components/Acl';
import CmsContext from 'context/CmsContext';
import TabContainer from './birth/TabContainer';
import TabDeathContainer from './death/TabDeathContainer';
import PSASettingsContainer from './settings/PSASettingsContainer';
import TransactionsContainer from './dashboard/TransactionsContainer';
import TabMarriageContainer from './marriage/TabMarriageContainer';
import BirthTabContainer from './cauayan/birth/BirthTabContainer';

function CIRSContainer({ match }) {
  const permissions = getJson('permissions');
  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType("VARIABLES");

  return (
    <div className="module-inner">
      <div className="module-inner-title">Civil Registry</div>
      <div className="generic-module-nav mb-3">
        {Acl(permissions, ['VIEW CIVIL REGISTRY']) && (
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/civil-registry"
          >
            Dashboard
          </NavLink>
        )}
        {Acl(permissions, ['VIEW BIRTH CERTIFICATE']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/civil-registry/birth-certificate"
          >
            Birth Certificate
          </NavLink>
        )}
        {Acl(permissions, ['VIEW DEATH CERTIFICATE']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/civil-registry/death-certificate"
          >
            Death Certificate
          </NavLink>
        )}
        {Acl(permissions, ['VIEW MARRIAGE CERTIFICATE']) && (
          <NavLink
            exact={false}
            className="nav-link"
            activeClassName="active"
            to="/civil-registry/marriage-certificate"
          >
            Marriage Certificate
          </NavLink>
        )}
      </div>
      <Switch>
        <Route exact path={`${match.path}`} component={TransactionsContainer} />
        {_.get(CMS_VARIABLES, 'ORGANIZATION') !== 'City of Cauayan' && (
          <Route
            path={`${match.path}/birth-certificate`}
            component={TabContainer}
          />
        )}
        {_.get(CMS_VARIABLES, 'ORGANIZATION') === 'City of Cauayan' && (
          <Route
            path={`${match.path}/birth-certificate`}
            component={BirthTabContainer}
          />
        )}
        <Route
          path={`${match.path}/death-certificate`}
          component={TabDeathContainer}
        />
        <Route
          path={`${match.path}/marriage-certificate`}
          component={TabMarriageContainer}
        />
        <Route
          path={`${match.path}/settings`}
          component={PSASettingsContainer}
        />
      </Switch>
    </div>
  );
}

CIRSContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(CIRSContainer);
